// matches any protocol
const PROTOCOL_REGEX = /^[a-z]+:(\/*)(?:www\.)?/i;

// used to extract the domain ($1) from a URL.  Matches any protocol or protocol-less domain,
// also matches bare domains.  Drops any path content.
const DOMAIN_REGEX = /^(?:(?:[a-z]+:)?\/\/)?(?:www\.)?([^\/]+).*/i;

export const safeUrlFilterModule = angular
  .module('Q.filters.safe-url-filter', [])

  .constant('safeUrl', function (s) {
    if (s) {
      s = s.toString();
      if (!PROTOCOL_REGEX.test(s)) {
        s = 'http://' + s.replace(/^[\/:]+/, '');
      }
    }
    return s;
  })

  .filter('safeUrl', function (safeUrl) {
    return safeUrl;
  })

  .filter('simpleUrl', function () {
    return function (s, domainOnly = false) {
      if (s) {
        if (domainOnly) {
          return s.toString().replace(DOMAIN_REGEX, '$1');
        } else {
          return s.toString().replace(PROTOCOL_REGEX, '');
        }
      } else {
        return s;
      }
    };
  });
